import { Suspense, lazy, type ComponentProps } from "react";

import type ThreadTerminalDrawer from "./ThreadTerminalDrawer";

/**
 * xterm and its seven addons are the single largest dependency in the client,
 * and a terminal only ever exists once the user opens one. Both screens that
 * render a drawer go through this wrapper so the chunk is shared and the
 * Suspense boundary is declared in one place.
 */
const LazyThreadTerminalDrawer = lazy(() => import("./ThreadTerminalDrawer"));

export function ThreadTerminalDrawerLazy(props: ComponentProps<typeof ThreadTerminalDrawer>) {
  return (
    <Suspense fallback={null}>
      <LazyThreadTerminalDrawer {...props} />
    </Suspense>
  );
}
